






















import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import CropImagePreviewComponent from '@components/cropImage/crop-image-preview.vue';
import ImagePreviewModel from 'crop-image/src/ImagePreviewModel';
import UiFileInputComponent from '@components/ui-file-input.vue';

//import ImagePreview from "@models/imagePreview";

@Component({
  name: 'image-preview-modal',
})
export default class ImagePreviewComponent extends Vue {
  @Prop({ type: Object, default: new ImagePreviewModel() }) value: ImagePreviewModel;
  @Prop({ default: true }) noCache!: boolean;
  @Prop({ default: true }) showError!: boolean;
  @Prop({ default: true }) required!: boolean;
  @Prop({ default: 1 }) aspectRatio: number;
  @Prop({ default: 100 }) elHight: number;

  cropImageUrl = '';
  file: File;
  cropFile: File;
  errorMessage: string = '';
  hasError: boolean = false;

  innervalue: ImagePreviewModel = this.value;
  @Watch('innervalue')
  onInnerValueChanged() {
    this.$emit('input', this.innervalue);
  }
  @Watch('value')
  onValueChanged() {
    this.innervalue = this.value;
  }

  get imageUrlPreview(): string {
    return this.innervalue.ImageUrl + (this.noCache ? `?no_cache=${new Date().getTime()}` : '');
  }

  setPositions(data: any) {
    this.innervalue = new ImagePreviewModel();
    this.innervalue.Width = parseInt(data.width);
    this.innervalue.Height = parseInt(data.height);
    this.innervalue.Top = parseInt(data.top);
    this.innervalue.Left = parseInt(data.left);
  }
  onCropUpdate(data: ImagePreviewModel) {
    this.setPositions(data);
  }
  onLoadFile(file: File) {
    this.cropFile = file;
    var fileToLoad = file;
    var fileReader = new FileReader();

    fileReader.onload = (fileLoadedEvent: any) => {
      var srcData = fileLoadedEvent.target.result;
      this.cropImageUrl = srcData;
    };
    fileReader.readAsDataURL(fileToLoad);
  }
  saveCrop() {
    this.file = this.cropFile;
    this.cropFile = null;
    (this.$refs.crop as any).forceUpdate();
    this.innervalue.ImageUrl = this.cropImageUrl;
    this.cropImageUrl = null;
    this.clearFile();
    this.isValid();
  }

  getSetParams() {
    return this.innervalue;
  }

  isValid(): boolean {
    this.errorMessage = '';
    if (this.required && (!this.innervalue.ImageUrl || this.innervalue.ImageUrl == '/assets/img/no_image.svg')) {
      this.errorMessage = '*Выберите изображение';
      this.hasError = true;
      return false;
    }
    this.hasError = false;
    return true;
  }

  getFile() {
    return this.innervalue;
  }

  clearFile() {
    this.cropImageUrl = null;
    (this.$refs.fileInput as UiFileInputComponent).setFile(this.file);
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/components/image-preview-modal.vue